import React from 'react';
import Background from '../Background'
import cx from 'classnames';
import get from 'lodash/get';
import './Header.css';
import Star1 from '../../assets/images/star1.png';
import Starone from "../../assets/images/starone.png";
import Startwo from "../../assets/images/startwo.png";

function Header({ data: {
  hideHeader, headerTitleImage, headerImage, headerImageLoading, images = []
}, onDeepLink, className, onTrackState, onTrackAction, ...otherProps }) {
  const onImageItemClick = (imageItem, index) => () => {
    onDeepLink && onDeepLink(get(imageItem, 'link'));
    const actionName = isLeftOrRight(index);
    onTrackAction && onTrackAction(actionName, JSON.stringify({ 'link.category': 'HarmonyLanding' }));
  };

  const renderTitle = (imageItem) => {
    const titleImage = get(imageItem, 'titleTagImage');
    return !!titleImage ? <img className="ribbon" src={titleImage} />
      : null;
  };

  const isLeftOrRight = (index) => {
    return index % 2 == 0 ? 'PromoLeft' : 'PromoRight'
  }
  return !hideHeader ? (
    <div className={cx('ha-header-root', className)} {...otherProps}>
      <Background className='ha-header-image' src={headerImage} placeholder={headerImageLoading}>
        <div className='header-content-texts'>
          <img src={headerTitleImage} />
        </div>

      </Background>
      {/* <div className='ha-header-images'>
        <img className='star1' src={Star1} alt="" />
        <div className='tile is-ancestor is-mobile'>
          {
            images && images.map((item, index) => {
              return <div key={index} className='tile is-child half-vw has-title'>
                <Background className="image"
                  src={get(item, 'image')}
                  placeholder={get(item, 'imageLoading')}
                  onClick={onImageItemClick(item, index)}
                >
                </Background>
                {renderTitle(item)}
              </div>
            })
          }
        </div>
      </div> */}
        <div className='ha-header-images'>
        <img className="starone" src={Starone} alt="" />
        <img className="startwo" src={Startwo} alt="" />
        <div className='tile is-ancestor is-mobile'>
          {
            images && images.map((item, index) => {
              return <div key={index} className='tile is-child half-vw has-title'>
                <Background className="image"
                  src={get(item, 'image')}
                  placeholder={get(item, 'imageLoading')}
                  onClick={onImageItemClick(item, index)}
                >
                </Background>
                {renderTitle(item)}
              </div>
            })
          }
        </div>
      </div>


    </div>
  ) : null;
}

export default Header;
